import axiosRequest from "@/utils/axios-utils";
import axios from "axios";

export const STORE_LOCATOR = async (productId) => {
  try {
    const req = await axios.post("/api/PDP/storeProduct", { productId });
    return req;
  } catch (error) {
    return error;
  }
};

export const addProductReview = async (
  handshake,
  mage,
  quote,
  rating,
  nickname,
  title,
  detail,
  productId
) => {
  const data = JSON.stringify({
    review: {
      title,
      detail,
      nickname,
      ratings: [
        {
          rating_name: "Rating",
          value: 5 || rating, // we have to send user rate value
        },
        {
          rating_name: "Quality",
          value: 5 || rating, // we have to send user rate value
        },
      ],
      review_entity: "product",
      review_status: 2,
      entity_pk_value: productId,
    },
  });

  let config = {
    method: "post",
    url: "/productReviews/add",
    headers: {
      Authorization: "Bearer " + handshake,
      quote: "Bearer " + quote,
    },
    data,
  };
  if (mage) {
    config.headers.mage = "Bearer " + mage;
  }
  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};

export const getProductsBySkus = async (handshake, skuBulk) => {
  const config = {
    method: "get",
    url: "/search/get-products-by-skus?skus=" + JSON.stringify(skuBulk),
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
  };

  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};

// used in pdp in client side
export const getDeliveryDetails = async () => {
  const config = {
    method: "get",
    url: `/pdp/get-active-pdp-details`,
  };

  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};

export const getAlgoliaProductRecommendations = async (handshake, objectId) => {
  const config = {
    method: "GET",
    url: `/algolia/recommendations?objectID=${objectId}`,
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
  };

  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};
